import React, { createContext, useContext, useMemo } from 'react'

type PocketComponentProgressBarStateContextType = {
    isProgressBarActive: boolean
}

const PocketComponentProgressBarStateContext =
    createContext<PocketComponentProgressBarStateContextType>(null!)

// This provider is used to tell the Prompt component if the progress bar is
// currently active in the PocketComponent. If so, the Prompt will disable itself.
//
// This is a hack to avoid having to update every single form with some state that
// tracks if it's currently in the middle of submitting.
export const PocketComponentProgressBarStateProvider = ({
    children,
    isProgressBarActive,
}: {
    children: React.ReactNode
    isProgressBarActive: boolean
}) => {
    const value = useMemo(() => ({ isProgressBarActive }), [isProgressBarActive])

    return (
        <PocketComponentProgressBarStateContext.Provider value={value}>
            {children}
        </PocketComponentProgressBarStateContext.Provider>
    )
}

export const usePocketComponentProgressBarStateContext = () => {
    return useContext(PocketComponentProgressBarStateContext)
}
